import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 bg-[#0d0d14] bg-noise relative border-t border-cyan-900/30" data-id="element-61">
      {/* Subtle top glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-px bg-gradient-to-r from-transparent via-cyan-accent/50 to-transparent shadow-[0_0_20px_rgba(0,212,255,0.5)]" data-id="element-62" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-10" data-id="element-64">
          <div className="inline-flex items-center justify-center p-4 bg-cyan-950/30 rounded-full border border-cyan-900/50 mb-4" data-id="element-65">
            <ShieldIcon className="w-10 h-10 text-cyan-accent" data-id="element-66" />
          </div>

          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-67">
            Tras analizar los fallos sistémicos de las crisis de 2020-2025,
            descubrimos una verdad incómoda: La supervivencia urbana no es
            cuestión de equipo táctico, es cuestión de arquitectura de sistemas.
          </p>

          <div className="py-8" data-id="element-68">
            <h2 className="text-2xl md:text-3xl font-medium text-gray-200 mb-4" data-id="element-69">
              No necesitas un cuchillo militar ni un búnker en la montaña.
              Necesitas un
            </h2>
            <h3 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-cyan-accent text-glow-cyan uppercase tracking-tight" data-id="element-70">
              Protocolo de Resiliencia 360°
            </h3>
          </div>

          <div className="bg-tactical-900/80 border border-tactical-800 p-8 rounded-xl shadow-2xl relative overflow-hidden" data-id="element-71">
            {/* Decorative corner accents */}
            <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-cyan-accent/50" data-id="element-72" />
            <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-cyan-accent/50" data-id="element-73" />
            <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-cyan-accent/50" data-id="element-74" />
            <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-cyan-accent/50" data-id="element-75" />

            <p className="text-lg text-gray-300 leading-relaxed" data-id="element-76">
              Un sistema sofisticado que convierta tu apartamento en una unidad
              autónoma (clima, energía, agua) mientras protege tu patrimonio del
              caos financiero (inflación, corralitos). Con solo{' '}
              <strong className="text-white" data-id="element-77">3 cambios estratégicos</strong> en
              tu hogar y <strong className="text-white" data-id="element-78">2 movimientos</strong>{' '}
              en tu cartera, serás más resiliente que el 99% de la población.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}